// Environment-based configuration
export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://eateazyapi.yorotechnologies.com/api";
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL || "http://localhost:3002";
export const STORE_KEY = process.env.REACT_APP_STORE_KEY || "ad474f88-ad7a-4b6a-a601-b6575da4ff85";

// GitHub Configuration
export const gitUrl = process.env.REACT_APP_GIT_URL || "https://raw.githubusercontent.com/Thwalhathabdulla/digital-foog-menu";
export const gitImageUrl = process.env.REACT_APP_GIT_IMAGE_URL || "https://raw.githubusercontent.com/Thwalhathabdulla/digital-foog-menu/main/menu/images/";

// App Configuration
export const APP_NAME = process.env.REACT_APP_NAME || "Digital Food Menu";
export const APP_VERSION = process.env.REACT_APP_VERSION || "0.1.0";
export const APP_DESCRIPTION = process.env.REACT_APP_DESCRIPTION || "Digital menu application for restaurants";

// API Settings
export const API_TIMEOUT = process.env.REACT_APP_API_TIMEOUT || 1000000;
export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE || "en";
export const DEFAULT_CURRENCY = process.env.REACT_APP_DEFAULT_CURRENCY || "USD";

// Feature Flags
export const ENABLE_ANALYTICS = process.env.REACT_APP_ENABLE_ANALYTICS === "true";
export const ENABLE_DEBUG_MODE = process.env.REACT_APP_ENABLE_DEBUG_MODE === "true";
export const ENABLE_WHATSAPP_SHARE = process.env.REACT_APP_ENABLE_WHATSAPP_SHARE === "true";

// Social Media
export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "+1234567890";
export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// Payment Configuration
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

// Firebase Configuration
export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Legacy URLs (commented out for reference)
// export const BASE_URL = "http://192.168.25.124:8000/api"
// export const BASE_URL = "https://tabaq.ae/admin/Api"
// export const IMAGE_URL = "https://api.tabaq.in"
// export const BASE_URL = "https://api.tabaq.in/api"
// export const BASE_URL = "http://15.185.218.57:8000/api"
